export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6563.03b045e9.jpg";